exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".footer-fc580{display:flex;flex-wrap:wrap;justify-content:center}.footer-fc580 div{width:50%}", ""]);

// Exports
exports.locals = {
	"footer": "footer-fc580"
};